
<div class="separator">
  <span><slot /></span>
</div>
